export var PetType;
(function (PetType) {
    PetType["DOG"] = "DOG";
    PetType["CAT"] = "CAT";
})(PetType || (PetType = {}));
